import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const itemChipStyles = {
	selectedModelChip: {
		flexShrink: 0,
		height: '30px',
		padding: '3px 8px 3px 4px',

		borderRadius: '24px',

		display: 'inline-flex',
		alignItems: 'center',
		gap: '4px',
		border: `1px solid ${colorPalette.light5}`,
		backgroundColor: 'colors.dark5',
	},
	selectedModelImageContainer: {
		flexShrink: 0,
		height: '24px',
		width: '24px',

		borderRadius: '24px',

		overflow: 'hidden',

		'& img': {
			objectFit: 'cover',
			height: '24px',
			width: '24px',
		},
	},
	selectedChipCrossButton: {
		display: 'flex',
		alignItems: 'center',
		justifyItems: 'center',

		cursor: 'pointer',

		'& svg': { height: '16px', width: 'auto' },
	},
};
